import { selectors as UserPreferencesSelectors } from 'data/userPreferences'
import { isCurrentUserTheOwner } from 'data/users/selectors'

const filterEmails = emails =>
  emails.filter(entry => entry.indexOf('@') > 0 && entry.length > 0)

const convertTextToEmails = text => filterEmails(text.split(/[ ,;]+/))

const getOnboardingStep = state =>
  UserPreferencesSelectors.getUserPreferences(state).get('onboardingStep')

const isOnboardingOnInviteStep = state => getOnboardingStep(state) === 'invite'
const isOnboardingOnChannelsStep = state =>
  getOnboardingStep(state) === 'channels'
const isOnboardingOnNotesStep = state => getOnboardingStep(state) === 'notes'
const isOnboardingActive = state => getOnboardingStep(state) !== 'done'
const isOwnerOnboardingActive = state =>
  isCurrentUserTheOwner(state) && isOnboardingActive(state)

export {
  filterEmails,
  convertTextToEmails,
  isOnboardingOnInviteStep,
  isOnboardingOnChannelsStep,
  isOnboardingOnNotesStep,
  isOnboardingActive,
  isOwnerOnboardingActive,
}
